import { Component, Input } from '@angular/core';
import { ProvedorConexao, ProvedorEndpoint } from '../../../types/smartinteg';
import { IteracaoForm, nomesDeVariaveis, previewIteracao } from './iteracao.util';

/**
 * Editor da parte específica de Recurso.configuracoes.iteracao: campos da listagem -> variáveis e o recurso
 * executado por item (com o seu comando de API). O comando da listagem é o comando do próprio recurso ITERACAO.
 * Edita o modelo recebido no lugar; quem salva usa o iteracao.util.
 */
@Component({
  selector: 'app-iteracao-config',
  templateUrl: './iteracao-config.component.html',
  styleUrls: ['./iteracao-config.component.css']
})
export class IteracaoConfigComponent {

  @Input() model!: IteracaoForm;
  @Input() aba = 'campos';
  @Input() conexoes: ProvedorConexao[] = [];
  @Input() endpointsGlobais: ProvedorEndpoint[] = [];

  // Sequência com chaves duplas montada aqui: o template não pode conter essa sequência literal
  readonly exemploVariavel = '{' + '{variável}' + '}';

  get variaveis(): string[] { return nomesDeVariaveis(this.model.campos); }
  get preview(): string[] { return previewIteracao(this.model.campos); }

  adicionarCampo(): void { this.model.campos.push({ campo: '', variavel: '' }); }
  removerCampo(i: number): void { this.model.campos.splice(i, 1); }
}
